module.exports = __webpack_public_path__ + "img/type3_bg.44deb8ed.png";